import React from 'react'

const About = () => {
  return (
    <section className="section about-section">
      <h1 className="section-title">about us</h1>
      <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quis doloremque ab, accusantium nobis repellat odio impedit magnam eius fugiat recusandae. Nisi aliquam asperiores, reprehenderit fugit facilis rem. Dolor, doloribus dignissimos. Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi reprehenderit facilis nam consequuntur nemo ducimus maxime fugiat sequi? Excepturi quod dolorem, quibusdam nisi dolores doloremque ratione corporis quis quidem commodi!</p>
    </section>
  )
}

export default About
